/** Returns the ids sorted by the name of the entities */
export const getIdsSortedByName = (entities: {
  [id: string]: { name: string };
}) => Object.keys(entities).toSorted((idA, idB) => entities[idA].name.localeCompare(entities[idB].name));
